import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API } from '../config';

const Feedback = ({ onClose }) => {
  const [userFeedback, setUserFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitFeedback = async (e) => {
    e.preventDefault();

    const trimmed = userFeedback.trim();
    if (!trimmed) {
      toast.info('Please enter your feedback before submitting.');
      return;
    }

    setIsSubmitting(true);

    try {
      // POST to our new feedback route
      await axios.post(`${API}/api/feedback`, {
        message: trimmed,
      });

      toast.success('Thank you for your feedback!', {
        autoClose: 3000,
        onClose: () => {
          setTimeout(() => {
            setUserFeedback('');
            onClose();
          }, 500);
        }
      });
    } catch (err) {
      console.error('Failed to send feedback:', err);
      toast.error('Oops—could not send your feedback. Please try again.');
    } finally {
          // NEW BLOCK: reset submission state
          setIsSubmitting(false);
      }
  };



  return (
    <section className="feedback">
      <ToastContainer position="top-right" autoClose={3000} />
        <div className="overlay">
            <form className="feedback-form" onSubmit={submitFeedback}>
                <IoClose className="close-icon" onClick={onClose}/>
                <div className="form-input">
                    <label htmlFor="feedback-textarea">
                        Share your thoughts, help us make this game better
                    </label>
                    <textarea
                        id="feedback-textarea"
                        name="feedback"
                        placeholder="Type your message here..."
                        value={userFeedback}
                        onChange={(e) => setUserFeedback(e.target.value)}
                        autoComplete="off"
                        rows={5}
                        disabled={isSubmitting}                  
                    />
                </div>

                <button type="submit" className="btn" id='feedback-button'>
                    <span className="btn-text">{isSubmitting ? 'Sending…' : 'Submit'} </span>
                </button>
            </form>
        </div>
        

    </section>
  );
};

export default Feedback;
